export default __webpack_public_path__ + "static/media/a023-01.6413082f.png";